export enum MapPane {
    BACKGROUND = 'backgroundPane',
    CUSTOM_GEODATA = 'customGeodataPane',
    LOCAL_AUTHORITIES = 'localAuthorityPane',
    MARKER = 'markerPane',
    OVERLAY = 'overlayPane',
    PREVIOUS_GEOMETRY = 'previousGeometryPane',
    STATIONS = 'stationPane',
    VEHICLES = 'vehiclePane'
}
